/**
 * Marka renkleriyle kare sosyal ikonlar (lucide’da resmi marka ikonları yok).
 * @param {{ className?: string, size?: number }} props
 */
export function SocialIconFacebook({ className = '', size = 40 }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            aria-hidden
        >
            <rect width="24" height="24" rx="4" fill="#1877F2" />
            <path
                fill="#ffffff"
                d="M14 13.5h2.5l.4-2.5H14V9.4c0-.7.4-1.2 1.3-1.2h1V6.1c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v1.7H7v2.5h2.6V22h3.4v-8.5z"
            />
        </svg>
    );
}

/** X (Twitter) — siyah kare, beyaz X */
export function SocialIconX({ className = '', size = 40 }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            aria-hidden
        >
            <rect width="24" height="24" rx="4" fill="#000000" />
            <path
                fill="none"
                stroke="#ffffff"
                strokeWidth="2.2"
                strokeLinecap="round"
                d="M7.5 7.5l9 9m0-9l-9 9"
            />
        </svg>
    );
}
